<template lang="pug">
	modal
		.card.text-left
			.card-header
				span.fa.fa-trash.mr-2
				| Recuperar inserciones
				button.close(@click="cerrar") &times;
			.card-body
				CalendarioAnual(:seleccion.sync="dias", :from="contrato.FechaInicio", :to="contrato.FechaFin", :resaltados="resaltados")
			.card-footer
				button.btn.btn-primary.btn-sm(@click="recuperar")
					span.fa.fa-trash.mr-2
					| Recuperar
</template>

<script>
import CalendarioAnual from '../../../../../gestion-emisoras/vue/componentes/utilidades/calendario-anual.vue'
export default {
	props: ['contrato', 'radiacion'],
	components: {
		CalendarioAnual
	},
	data () {
		return {
			dias: []
		}
	},
	computed: {
		resaltados () {
			return this.radiacion.lineas.reduce((acc, linea) => {
				acc = linea.inserciones.reduce((acc, insercion) => {
					if (acc.indexOf(insercion.Dia) < 0 && insercion.Anulada) {
						acc.push(insercion.Dia)
					}
					return acc
				}, acc)
				return acc
			}, [])
		}
	},
	methods: {
		filtrar () {
			this.dias = this.dias.filter(d => {
				const diaStr = this.$moment(d).format('YYYY-MM-DD')
				return (this.resaltados.indexOf(diaStr) >= 0)
			})
		},
		recuperar () {
			this.filtrar()
			this.$emit('recuperar', this.dias)
			this.cerrar()
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/radiacion/vue/components/radiacion/recuperar/recuperar-inserciones.vue